import Icon from '../../../components/AppIcon';

const AboutSection = ({ photographer }) => {
  return (
    <div className="space-y-6 md:space-y-8">
      {/* حقل نبذة عن المصور مخفي حسب الطلب — قسم نبذة عني يبقى مع الإحصائيات والمعدات واللغات */}
      {/* Experience & Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <div className="bg-card border border-border rounded-xl p-4 md:p-6 text-center">
          <div className="w-12 h-12 md:w-14 md:h-14 bg-success/10 rounded-xl flex items-center justify-center mx-auto mb-3">
            <Icon name="CheckCircle" size={24} className="text-success" />
          </div>
          <div className="text-2xl md:text-3xl font-bold text-foreground mb-1">
            {photographer?.completedBookings}+
          </div>
          <p className="text-xs md:text-sm text-muted-foreground">حجز مكتمل</p>
        </div>

        <div className="bg-card border border-border rounded-xl p-4 md:p-6 text-center">
          <div className="w-12 h-12 md:w-14 md:h-14 bg-warning/10 rounded-xl flex items-center justify-center mx-auto mb-3">
            <Icon name="Star" size={24} className="text-warning" />
          </div>
          <div className="text-2xl md:text-3xl font-bold text-foreground mb-1">
            {photographer?.rating}
          </div>
          <p className="text-xs md:text-sm text-muted-foreground">تقييم عام</p>
        </div>
      </div>
      {/* Shooting Methods */}
      <div className="grid grid-cols-1 gap-6 md:gap-8">
        <div className="bg-card border border-border rounded-xl p-6 md:p-8">
          <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
            <Icon name="Camera" size={24} className="text-primary" />
            وسائل التصوير
          </h3>
          {Array.isArray(photographer?.shootingMethods) && photographer.shootingMethods.length > 0 ? (
            <ul className="space-y-3">
              {photographer.shootingMethods.map((method, index) => {
                const label =
                  method === 'professional_camera' ? 'كاميرا احترافية'
                  : method === 'mobile_camera'     ? 'كاميرا جوال'
                  : method === 'drone'             ? 'تصوير جوي (درون)'
                  : method;
                const model = photographer?.shootingMethodModels?.[method];
                return (
                  <li key={index} className="flex items-start gap-2 text-sm md:text-base text-foreground">
                    <Icon name="Check" size={18} className="text-success flex-shrink-0 mt-0.5" />
                    <div>
                      <span className="font-medium">{label}</span>
                      {model && (
                        <span className="block text-xs text-muted-foreground mt-0.5">{model}</span>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="text-sm md:text-base text-muted-foreground">
              لم يتم تحديد وسائل التصوير بعد
            </p>
          )}
        </div>
      </div>
      {/* Equipment */}
      <div className="bg-card border border-border rounded-xl p-6 md:p-8">
        <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Wrench" size={24} className="text-primary" />
          المعدات المتاحة
        </h3>
        {photographer?.languages && photographer.languages.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {photographer.languages.map((language, index) => (
              <span
                key={index}
                className="px-4 py-2 bg-muted rounded-lg text-sm md:text-base text-foreground"
              >
                {language}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-sm md:text-base text-muted-foreground">
            لم يتم تحديد المعدات بعد
          </p>
        )}
      </div>
    </div>
  );
};

export default AboutSection;